<template>
    <div v-if="faqItems.length > 0">
        <div class="FA-Question">
            <div class="FA-Question-search">
                <!-- 船队分类 -->
                <div class="FA-shipType">
                    <div class="selectItem selectItem-titleStyle noborder js-openShipsList" @click="isShowShipCategorySelect=true">
                        <span>
                            <span class="selectItem-title">{{selectedShipCategory.title}}</span>
                            <span class="selectItem-subtitle">{{selectedShipCategory.subTitle}}</span>
                        </span>
                        <img src="https://resource.rcclchina.com.cn/Faq/arrowDownIcon.png" alt="下拉箭头icon" />
                    </div>
                    <div class="shipType-selectContainer" v-show="isShowShipCategorySelect">
                        <div class="shipType-selectCon-bg js-closeShipBtn" @click="isShowShipCategorySelect=false"></div>
                        <div class="shipType-selectCon scroll-container js-selectShipBtn">
                            <div class="selectItem"
                                v-for="(shipCategory, i) in shipCategories" :key="('shipCategory_'+i)"
                                @click="onShipCategoryChange(shipCategory)"
                            >
                                <span>
                                    <span class="selectItem-title">{{shipCategory.title}}</span>
                                    <span class="selectItem-subtitle">{{shipCategory.subTitle}}</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 关键字搜索 -->
                <div class="input-search">
                    <div class="input-searchContainer">
                        <div class="searchIcon">
                            <img src="https://resource.rcclchina.com.cn/Faq/searchIconN.png" alt="搜索Icon" />
                        </div>
                        <form action="" onsubmit="return false;">
                            <input type="search" class="input-searchTxt" placeholder="请输入问题关键字,如:游玩/消费/会员" id="input-searchTxt"
                            v-model="searchKeyword" @change="onSearchKeywordChange">
                        </form>
                        <div class="searchClosedIcon js-searchClosedBtn" @click="clearSearchKeyword">
                            <img class="button-searchClosedBtn" src="https://resource.rcclchina.com.cn/Faq/searchClosedIcon.png" alt="清空搜索关键字" />
                        </div>
                    </div>
                </div>

                <!-- FAQ分类 -->
                <div class="FA-Question-nav js-navChangeBtn">
                    <div class="swiper-container">
                        <div class="faq-categories-wrapper" ref="faqCategoriesWrapper" @scroll="onFaqCategoriesWrappScroll">
                            <div class="faq-categories-slide" >
                                <div class="FA-categoriesItem" :class="{ active: selectedFaqCategory.category == '热门'}"
                                @click="onFaqCategoryHotNewClick('热门')"
                                >
                                    <span data-category="hot_content2">热门</span>
                                </div>
                            </div>
                            <div class="faq-categories-slide" v-for="(faqCategory, i) in faqCategories" :key="('faqCategory_'+i)"
                            >
                                <div class="FA-categoriesItem" :class="{ active: selectedFaqCategory.id == faqCategory.id}"
                                @click="onFaqCategoryClick(faqCategory)">
                                    <span>{{faqCategory.name}}</span>
                                    <img v-if="faqCategory.subCategories && faqCategory.subCategories.length>0"
                                        src="https://resource.rcclchina.com.cn/Faq/arrowDownBIcon.png" alt="下拉箭头icon" />
                                </div>
                            </div>
                            <div class="faq-categories-slide" ref="faqCategoriesSlideAll">
                                <div class="FA-categoriesItem" :class="{ active: selectedFaqCategory.category == '全部'}"
                            @click="onFaqCategoryHotNewClick('全部')">
                                    <span data-category="">全部</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 左右按钮 -->
                    <div class="swiper-button-prev" v-show="isShowFaqCategoryLeftArrow">
                        <img src="https://resource.rcclchina.com.cn/Faq/leftIcon.png" />
                        <img src="https://resource.rcclchina.com.cn/Faq/leftIcon.png" />
                    </div>
                    <div class="swiper-button-next" v-show="isShowFaqCategoryRightArrow">
                        <img src="https://resource.rcclchina.com.cn/Faq/rightIcon.png" />
                        <img src="https://resource.rcclchina.com.cn/Faq/rightIcon.png" />
                    </div>

                    <div class="FA-subCategories" v-show="isShowFaqSubCategories==true">
                        <div class="FA-subCategoriesCon">
                            <ul class=" js-subTabChange">
                                <li v-for="(subCategory) in subFaqCategories" :key="('subCategory_'+subCategory.id)"
                                :class="{ active: selectedFaqCategory.subId==subCategory.id}"
                                @click="onSubFaqCategoryClick(subCategory)">
                                    {{subCategory.name}}
                                </li>
                            </ul>
                        </div>
                    </div>

                </div>

            </div>

            <div class="searchResult">
                <div id="searchResult">
                    <div class="FA-Question-item js-openAnswer" v-for="(faqItem) in targetFaqItems" :key="'faqItem_' + faqItem.id"
                    @click="onFaqClick(faqItem)">
                        <div class="FA-Question-itemL">
                            <div class="itemL-question" v-html="faqItem.question">
                            </div>
                            <div class="itemL-hotIcon" v-show="selectedFaqCategory.category=='热门'">
                                <img src="https://resource.rcclchina.com.cn/Faq/hotimg.png">
                            </div>
                        </div>
                        <div class="FA-Question-itemR"><span class="faq-item-arrow" aria-hidden="true"></span></div>
                    </div>
                </div>
            </div>
        </div>
        <FaqDetailPopup
            v-show="isShowFaqDetailPopup"
            :faq="targetFaq"
            :selectedShipCategory="selectedShipCategory"
            :onFaqFeedbackSuccess="onFaqFeedbackSuccess"
            :onPopupClose="onFaqDetailPopupClose"
        />
    </div>
</template>

<script>
import _ from 'lodash'
import {gioTracking} from "@/utilities/tools";
const FaqDetailPopup = () => import('@/components/Faq/FaqDetailPopup')
export default {
    name: "Faq",
    components: {
        FaqDetailPopup
    },
    asyncData ({ store }) {
        const userToken = store.state.user.userReviewToken
        return new Promise((resolve, reject) => {
            return store.dispatch('GET_FAQ', {
                userName: userToken
            })
            .then(()=> {
                resolve();
            })
            .catch((e)=> {
                reject(e)
            })
        })
    },
    data() {
        return {
            selectedShipCategory: {},
            targetFaqItems: [],
            searchKeyword: "",
            isShowFaqSubCategories: false,
            selectedFaqCategory: {
                id: 0,
                subId: 0,
                category: "热门",
                subCategory: ""
            },
            tempFaqCategoryId: 0,
            isShowFaqCategoryLeftArrow: false,
            isShowShipCategorySelect: false,
            isShowFaqCategoryRightArrow: true,
            faqCategoriesWrapperWidth: 0,
            targetFaq: {},
            isShowFaqDetailPopup: false
        }
    },
    beforeMount () {
        this.$store.commit('SET_PAGE_TITLE', '常见问题')
    },
    methods: {
        searchFaqItems () {

            // 先要有分类
            let faqItems = this.faqItems.filter(r=>r.category && r.category.length > 0)

            // 先过滤船队分类
            faqItems = faqItems.filter(r=>r.promoFaqCategories && r.promoFaqCategories.some(c=>c.id == this.selectedShipCategory.id))

            // 过滤关键字
            if (this.searchKeyword && this.searchKeyword.trim().length > 0) {
                const keyword = this.searchKeyword.trim().toUpperCase()
                faqItems = faqItems.filter(r=>r.question && r.answer
                && (r.question.toUpperCase().indexOf(keyword)>= 0 || r.answer.toUpperCase().indexOf(keyword)>= 0 ))

            }

            if (this.selectedFaqCategory.category != "全部") {
                 // 过滤FAQ分类
                if (this.selectedFaqCategory.category == "热门") {
                    faqItems = faqItems.filter(r=>r.isHot)
                } else if (!this.selectedFaqCategory.subCategory || this.selectedFaqCategory.subCategory == ''){
                    faqItems = faqItems.filter(r=>r.category == this.selectedFaqCategory.category)
                } else {
                    faqItems = faqItems.filter(r=>r.category == this.selectedFaqCategory.category
                    && r.subCategory == this.selectedFaqCategory.subCategory)
                }
            }

            if (faqItems.length > 0) {
                // 按照seq排序
                faqItems = _.orderBy(faqItems, ['seq'], ['desc'])

                // 如果搜索的话，按照tag排序
                if (this.searchKeyword && this.searchKeyword.length > 0) {
                    faqItems = this.sortFilterFaq(this.searchKeyword, faqItems)
                }
            }

            this.targetFaqItems = faqItems
        },
        sortFilterFaq (text, faqItems){
            text = text.toUpperCase()
            var topFaqs = []
            var otherFaqs = []
            for (var i = 0; i < faqItems.length; i++) {
                var faq = faqItems[i]
                if (faq.tags && faq.tags.toUpperCase().indexOf(text) >= 0) {
                    topFaqs.push(faq)
                } else {
                    otherFaqs.push(faq)
                }
            }
            topFaqs = _.orderBy(topFaqs, ['seq'], ['desc'])
            otherFaqs = _.orderBy(otherFaqs, ['seq'], ['desc'])

            faqItems = topFaqs.concat(otherFaqs)
            return faqItems
        },
        onShipCategoryChange (shipCategory) {
            this.selectedShipCategory = shipCategory
            this.searchFaqItems()
            this.isShowShipCategorySelect = false
        },
        onSearchKeywordChange () {
            if (this.searchKeyword && this.searchKeyword.trim().length > 0) {
                this.$refs.faqCategoriesWrapper.scroll({
                    left: this.$refs.faqCategoriesSlideAll.offsetLeft + this.$refs.faqCategoriesSlideAll.offsetWidth
                , behavior: 'smooth' })
                this.selectedFaqCategory = {
                    id: 0,
                    subId: 0,
                    category: "全部",
                    subCategory: ""
                }
                try {
                    window.gio('page.set', 'FAQ_WD', this.searchKeyword)
                } catch (e) {
                    console.error(e)
                }
            }
            this.searchFaqItems()
        },
        clearSearchKeyword () {
            this.searchKeyword = ''
            this.onSearchKeywordChange()
        },
        onFaqCategoryHotNewClick (value) {
            this.selectedFaqCategory.id = 0
            this.selectedFaqCategory.subId = 0
            this.selectedFaqCategory.category = value
            this.selectedFaqCategory.subCategory = ''

            gioTracking('track', 'evt_ButtonClicked',{
              'btnType': `FAQ${value}`
            })
            this.searchFaqItems()
        },
        onFaqCategoryClick (faqCategory) {

            gioTracking('track', 'evt_ButtonClicked',{
              'btnType': `FAQ${faqCategory.name}`
            })
            if (faqCategory.subCategories && faqCategory.subCategories.length > 0) {
                this.isShowFaqSubCategories = true
                this.tempFaqCategoryId = faqCategory.id
            } else {
                this.isShowFaqSubCategories = false
                this.selectedFaqCategory.subId = 0
                this.selectedFaqCategory.subCategory = ''
                this.selectedFaqCategory.id = faqCategory.id
                this.selectedFaqCategory.category = faqCategory.name
                this.searchFaqItems()
            }
        },
        onSubFaqCategoryClick (subFaqCategory) {
            this.selectedFaqCategory.subId = subFaqCategory.id
            this.selectedFaqCategory.subCategory = subFaqCategory.name
            const faqCategory = this.faqCategories.find(r=>r.id == subFaqCategory.parentId)
            if (faqCategory && faqCategory.id > 0) {
                this.selectedFaqCategory.id = faqCategory.id
                this.selectedFaqCategory.category = faqCategory.name
            }
            this.isShowFaqSubCategories = false
            this.searchFaqItems()
        },
        onFaqClick (faqItem) {
            this.targetFaq = faqItem
            this.isShowFaqDetailPopup = true
        },
        onFaqDetailPopupClose () {
            this.isShowFaqDetailPopup = false
        },
        onFaqFeedbackSuccess (faqId, type) {
            const faqItem = this.faqItems.find(r=>r.id == faqId)
            if (faqItem) {
                faqItem.suggestionType = type
            }
        },
        // 是否显示左右箭头
        onFaqCategoriesWrappScroll () {
            const scrollX = this.$refs.faqCategoriesWrapper.scrollLeft
            const width = this.$refs.faqCategoriesWrapper.offsetWidth
            // 初始计算滚动长度
            if (this.faqCategoriesWrapperWidth < 100) {
                let width = 0
                let eles = document.getElementsByClassName('faq-categories-slide')
                for (let i = 0; i < eles.length; i++) {
                    width += eles[i].offsetWidth
                }
                this.faqCategoriesWrapperWidth = width
            }
            // 显示隐藏左箭头
            if (scrollX > 26 && !this.isShowFaqCategoryLeftArrow) {
                this.isShowFaqCategoryLeftArrow = true
            } else if (scrollX <= 26 && this.isShowFaqCategoryLeftArrow) {
                this.isShowFaqCategoryLeftArrow = false
            }

            // 显示隐藏右箭头
            if (scrollX + width > this.faqCategoriesWrapperWidth - 50 && this.isShowFaqCategoryRightArrow) {
                this.isShowFaqCategoryRightArrow = false
            } else if (scrollX + width <= this.faqCategoriesWrapperWidth - 50 && !this.isShowFaqCategoryRightArrow) {
                this.isShowFaqCategoryRightArrow = true
            }
        }
    },
    computed: {
        pageData () {
            return this.$store.state.page.faqData
        },
        faqItems () {
            return this.pageData.itemViewModels || []
        },
        shipCategories () {
            return this.pageData.categories || []
        },
        faqCategories () {
            return this.pageData.faqCategories || []
        },
        subFaqCategories () {
            const faqCategory = this.faqCategories.find(r=>r.id == this.tempFaqCategoryId)
            if (!faqCategory || !faqCategory.subCategories) {
                return []
            }
            return faqCategory.subCategories
        }
    },
    watch: {
        pageData (newValue) {
            const query = this.$router.currentRoute.query
            if (!query || query.source != 'LOCAL_REWARD') return
            if (newValue && newValue.faqCategories && newValue.faqCategories.length > 0) {
                let rewardCategory = newValue.faqCategories.find(r=> r.name == '皇家游享荟')
                if (rewardCategory && rewardCategory.id > 0) {
                    this.selectedFaqCategory.category = rewardCategory.name
                    this.selectedFaqCategory.id = rewardCategory.id
                    this.selectedFaqCategory.subCategory = ""
                    this.$nextTick(()=> {
                        this.$refs.faqCategoriesWrapper.scroll({
                            left: this.$refs.faqCategoriesSlideAll.offsetLeft + this.$refs.faqCategoriesSlideAll.offsetWidth
                        , behavior: 'smooth' })
                    })
                }
            }
        },
        shipCategories (newValue) {
            if (newValue && newValue.length > 0) {
                this.selectedShipCategory = newValue[0]
            }
        },
        faqItems () {
            this.searchFaqItems()
        }
    }
}
</script>

<style lang="less" scoped>

.FA-Question {
    background-color: #fff;
    position:relative;
}

.FA-Question-search {
    margin-top:50px;
    background-color: #021156;
}
/**** 关键字搜索 ****/
.input-search {
    width: 100%;
    color: #fff;
    overflow: hidden;
    padding-bottom: 10px;
}
.input-searchContainer {
    width: 94%;
    margin: 0 auto;
    height: 33px;
    position: relative;
    background-color: #fff;
}
.input-search .input-searchTxt {
    width: 80%;
    line-height: 23px;
    font-size: 13px;
    padding: 5px 0;
    padding-left: 40px;
    border: none;
    box-shadow: none;
    -webkit-appearance: none !important;
    background-color: #fff;
    color: #000;
}
.input-search .searchIcon {
    position: absolute;
    left: 8px;
    top: 4px;
}
.input-search .searchIcon img {
    width: 19px;
    height: 19px;
    vertical-align: middle;
}
.input-search .searchClosedIcon {
    position: absolute;
    top: 4px;
    right: 2%;
}
.input-search .searchClosedIcon img {
    width: 26px;
    height: 26px;
    padding: 4px;
}

/**** 分类 ****/
.FA-Question-nav {
    background-color: #fff;
    border-bottom: 1px solid #e8e8e8;
    border-top-left-radius:6px;
    border-top-right-radius:6px;
    position:relative;
}
.FA-Question-nav .FA-categoriesItem{
    position:relative;
    height:36px;
    line-height:36px;
    text-align:center;
    padding-right:30px;
}
.FA-Question-nav .FA-categoriesItem>span{
    font-size:13px;
    color:#031351;
    display:inline-block;
    height:100%;
}
.FA-Question-nav .FA-categoriesItem>img{
    width:9px;
    display:inline-block;
}
.FA-Question-nav .FA-subCategories {
    width:100%;
    position:absolute;
    top:30px;
    background-color:#fff;
    padding-left:30px;
    z-index:11;
    box-shadow:0 4px 14px rgba(0,0,0,.2);
    -webkit-box-shadow:0 4px 14px rgba(0,0,0,.2);
    -moz-box-shadow:0 4px 14px rgba(0,0,0,.2);
}
.FA-Question-nav .FA-subCategoriesCon {
    padding: 11px 18px 0 0;
}
.FA-Question-nav .FA-subCategoriesCon ul {
    overflow:hidden;
    list-style:none;
    padding:0;
    margin:0;
}
.FA-Question-nav .FA-subCategoriesCon ul li{
    float:left;
    padding:2px 12px;
    background-color:#f3f3f3;
    font-size:13px;
    color:#031651;
    margin-right:10px;
    margin-bottom:10px;
}
.FA-Question-nav .FA-categoriesItem.active >span{
    border-bottom:4px solid #fec013;
    font-weight:bold;
}
.FA-Question-nav .FA-subCategoriesCon ul li.active{
    background-color:#fec013;
}
.FA-Question-nav .swiper-container {
    margin:0 30px;
    padding-bottom: 0px;
}

.FA-Question-nav .swiper-container  .faq-categories-wrapper {
    width: auto;
    height: 36px;
    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap;
}

// .FA-Question-nav .swiper-container  .faq-categories-wrapper::-webkit-scrollbar { width: 0 }

.FA-Question-nav .faq-categories-slide {
    width: auto;
    display: inline-block;
    vertical-align: middle;
}
.FA-Question-nav .swiper-button-prev,
.FA-Question-nav .swiper-button-next{
    transform:scale(.4);
    -webkit-transform:scale(.4);
    -moz-transform:scale(.4);
    -ms-transform:scale(.4);
    -o-transform:scale(.4);
}
.FA-Question-nav .swiper-button-prev {
    width:54px;
    /*background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z'%20fill%3D'%23007aff'%2F%3E%3C%2Fsvg%3E");*/
    background-image:none;
    opacity:1;
    left:-2px;
    // display:none;
}
.FA-Question-nav .swiper-button-next {
    width:54px;
    /*background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%23007aff'%2F%3E%3C%2Fsvg%3E");*/
    background-image:none;
    right:-18px;
}
.FA-Question-nav .swiper-button-prev img,
.FA-Question-nav .swiper-button-next img{
    width:50%;
}
.FA-Question-nav .swiper-button-prev img{
    margin-left:-40%;
}
.FA-Question-nav .swiper-button-next img{
    margin-right:-40%;
}

.FA-Question-nav .swiper-button-next img:first-child{
    margin-right:-30%;
}

.FA-Question-nav .swiper-button-prev img:last-child {
     margin-left:-30%;
}

/**** 搜索结果 ****/
.FA-Question #searchResult {
    padding-bottom: 50px;
    height: calc(100vh - 124px - 50px);
    overflow: scroll;
}
.FA-Question-item {
    overflow: hidden;
    width: 94%;
    margin: 0 auto;
    padding: 6px 10px;
    border-bottom: 1px solid #d8d8d8;
}
.FA-Question-item .FA-Question-itemL{
    float:left;
    width:96%;
}

.FA-Question-item .FA-Question-itemL .itemL-hotIcon{
    width:25px;
    display:inline-block;
    vertical-align:top;
    margin-top:8px;
}
.FA-Question-item .FA-Question-itemL .itemL-hotIcon img{
    width:100%;
    vertical-align:middle;
}
.FA-Question-item .FA-Question-itemR{
    float:right;
    margin-top:18px;
}
.FA-Question-item .FA-Question-itemR .faq-item-arrow{
    display:block;
    width:9px;
    height:9px;
    border-top:1px solid #000d57;
    border-right:1px solid #000d57;
    transform:rotate(45deg);
    -webkit-transform:rotate(45deg);
}


/**** 船队分类 *****/
.FA-shipType {
    position:relative;
}
.shipType-selectContainer {

}
.FA-shipType .shipType-selectCon-bg {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.6);
}
.FA-shipType .shipType-selectCon {
    width: 100%;
    height: auto;
    max-height: 360px;
    overflow-y: auto !important;
    background-color: #fff;
    position: fixed;
    left: 0;
    top: 92px;
    z-index: 20;
}
.FA-shipType .selectItem {
    padding-left: 32%;
    height: 44px;
    line-height: 44px;
    border-top: 1px solid #e0e0e0;
}
.FA-shipType .selectItem .selectItem-title{
    color:#000d57;
    font-size:13px;
    font-weight:bold;
}
.FA-shipType .selectItem .selectItem-subtitle{
    color:#000d57;
    font-size:13px;
    font-weight:100;
    margin-left:5px;
}
.FA-shipType .selectItem>img{
    width:9px;
    margin-left: 5px;
}
.FA-shipType .shipType-selectCon .selectItem-title{
    margin-right:14px;
}
.FA-shipType .selectItem.selectItem-titleStyle .selectItem-title,
.FA-shipType .selectItem.selectItem-titleStyle .selectItem-subtitle {
    color:#fff;
}
.FA-shipType .selectItem.noborder{
    border:none;
}
</style>

<style lang="less">
.FA-Question-item .FA-Question-itemL .itemL-question {
    width:88%;
    color:#000d57;
    font-size:12px;
    display:inline-block;
}
</style>
